// localStorage-backed clipboard for form editor variables and flags, so items
// copied in one form's editor can be pasted into another form (or another tab).
const KEYS = {
    vars: 'formEditorClipboard.vars',
    flags: 'formEditorClipboard.flags'
};

export function writeClipboard(kind, items) {
    try {
        localStorage.setItem(KEYS[kind], JSON.stringify(items));
    } catch (e) {
        // Storage unavailable/full — copy silently becomes a no-op.
    }
}

// Returns a fresh deep copy on every call (JSON round-trip), so pasted items
// never share references with the clipboard or earlier pastes.
export function readClipboard(kind) {
    try {
        const items = JSON.parse(localStorage.getItem(KEYS[kind]));
        return Array.isArray(items) ? items : [];
    } catch (e) {
        return [];
    }
}
